import SetQuinielaHeaders from './SetQuinielaHeaders';
export default SetQuinielaHeaders;
